import { Col, Form, Row } from 'antd'
import React from 'react'
import CheckBoxUC from '../../../components/Form/CheckBoxUC'
import InputUC from '../../../components/Form/InputUC'
import HeaderBarAdd from '../headerBarAdd'
import AttachFile from '../attachment/attachFile'

const CapabilityDriving = ({ props }) => {
    const {
        form,
        rcAttachFile,
        isReadOnly
    } = props
    props = {
        ...props,
        isLicense: true
    }
    const isMotorcyLicense = Form.useWatch('isMotorcyLicense', form);
    const isCarLicense1 = Form.useWatch('isCarLicense1', form);
    const isCarLicense2 = Form.useWatch('isCarLicense2', form);
    const isCarLicense3 = Form.useWatch('isCarLicense3', form);
    const isCarLicense4 = Form.useWatch('isCarLicense4', form);
    const isMotorcyLicenseUnderExam = Form.useWatch('isMotorcyLicenseUnderExam', form)
    const isCarLicense1UnderExam = Form.useWatch('isCarLicense1UnderExam', form)
    const isCarLicense2UnderExam = Form.useWatch('isCarLicense2UnderExam', form)
    const isCarLicense3UnderExam = Form.useWatch('isCarLicense3UnderExam', form)
    const isCarLicense4UnderExam = Form.useWatch('isCarLicense4UnderExam', form)
    const isMobile = window.innerWidth <= 768

    const handleChange = (e, columnName) => {
        let inputValue = e.target.value;
        // const reg = /^-?\d*(\.\d*)?$/;
        // if (!(reg.test(inputValue) || inputValue === '' || inputValue === '-')) {
        //     inputValue = inputValue.length > 0 ? (inputValue.substring(0, inputValue.length - 1)) : ''
        // }
        form.setFieldsValue({ [columnName]: inputValue });
    };

    const handleSetNull = (columnName) => {
        form.resetFields([columnName])
    }

    const handleChangeUnderExam = (e, columnName) => {
        //เมื่อมีการ check ความสามารถให้ clear อยู่ระหว่างการสอบ
        form.resetFields([columnName])
        //เมื่อมีการ check ความสามารถให้ clear ค่า input 
        handleSetNull(e)
    }

    const motorcyLicenseData = rcAttachFile && rcAttachFile?.filter((r) => r.documentType === 'motorcyLicense').length > 0
    const car1LicenseData = rcAttachFile && rcAttachFile?.filter((r) => r.documentType === 'car1License').length > 0
    const car2LicenseData = rcAttachFile && rcAttachFile?.filter((r) => r.documentType === 'car2License').length > 0
    const car3LicenseData = rcAttachFile && rcAttachFile?.filter((r) => r.documentType === 'car3License').length > 0
    const car4LicenseData = rcAttachFile && rcAttachFile?.filter((r) => r.documentType === 'car4License').length > 0

    // const FormDriving = () => {
    return (
        <>
            <div className='div-cap-lang w-full'>
                <HeaderBarAdd title={'ความสามารถในการขับขี่'} disabled={true} isShow={false} />
                <Row className="isMotorcyLicense py-2">
                    <Col span={24} className='px-2 div-checkbox-driving'>
                        <CheckBoxUC
                            disabled={isReadOnly}
                            // onChange={(ev) => handleSetNull('motorcyLicenseNo')}
                            onChange={(ev) => handleChangeUnderExam('motorcyLicenseNo', 'isMotorcyLicenseUnderExam')}
                            label='รถจักรยานยนต์'
                            name={'isMotorcyLicense'}
                            isShowHead={false} />
                    </Col>
                </Row>
                {isMotorcyLicense &&
                    <>
                        <Row className="motorcyLicenseNo py-2">
                            <Col xs={24} md={16} className='px-2'>
                                {isMotorcyLicenseUnderExam ?
                                    <InputUC label='ใบอนุญาตขับรถจักรยานยนต์' name={'motorcyLicenseNo'} maxLength={20}
                                        disabled={true} placeholder={''} /> :
                                    <InputUC label='ใบอนุญาตขับรถจักรยานยนต์' name={'motorcyLicenseNo'} maxLength={20}
                                        disabled={isReadOnly}
                                        required={motorcyLicenseData}
                                        onChange={(ev) => handleChange(ev, 'motorcyLicenseNo')} />
                                }
                            </Col>
                            <Col xs={24} md={8} className={`px-2 flex ${isMobile ? 'justify-start' : 'justify-center'} items-center div-checkbox`}>
                                <CheckBoxUC disabled={isReadOnly} label='อยู่ระหว่างการสอบ' name={'isMotorcyLicenseUnderExam'} onChange={(ev) => handleSetNull('motorcyLicenseNo')} />
                            </Col>
                        </Row>
                    </>
                }
                <AttachFile props={{ ...props, isLicenseChecked: isMotorcyLicense, isUnderExam: isMotorcyLicenseUnderExam }} docType={'motorcyLicense'} />
                <Row className="title py-2">
                    <Col span={24} className='px-2 div-checkbox-driving'>
                        <CheckBoxUC
                            label='รถยนต์ประเภท 1 (รถยนต์นั่งส่วนบุคคลไม่เกิน 7 คน)'
                            name={'isCarLicense1'}
                            isShowHead={false}
                            // onChange={(ev) => handleSetNull('carLicense1No')}
                            onChange={(ev) => handleChangeUnderExam('carLicense1No', 'isCarLicense1UnderExam')}
                            disabled={isReadOnly}
                        />
                    </Col>
                </Row>
                {isCarLicense1 &&
                    <>
                        <Row className="carLicense1No py-2">

                            <Col xs={24} md={16} className='px-2' >
                                {isCarLicense1UnderExam ?
                                    <InputUC label='ใบอนุญาตขับรถยนต์ประเภท 1' name={'carLicense1No'} maxLength={20}
                                        disabled={true} placeholder={''} /> :
                                    <InputUC label='ใบอนุญาตขับรถยนต์ประเภท 1' name={'carLicense1No'} maxLength={20}
                                        disabled={isReadOnly}
                                        required={car1LicenseData}
                                        onChange={(ev) => handleChange(ev, 'carLicense1No')} />
                                }

                            </Col>
                            <Col xs={24} md={8} className={`px-2 flex ${isMobile ? 'justify-start' : 'justify-center'} items-center div-checkbox`}>
                                <CheckBoxUC disabled={isReadOnly} label='อยู่ระหว่างการสอบ' name={'isCarLicense1UnderExam'} onChange={(ev) => handleSetNull('carLicense1No')} />
                            </Col>
                        </Row>

                    </>
                }
                <AttachFile props={{ ...props, isLicenseChecked: isCarLicense1, isUnderExam: isCarLicense1UnderExam }} docType={'car1License'} />
                <Row className="isCarLicense2 py-2">
                    <Col span={24} className='px-2 div-checkbox-driving'>
                        <CheckBoxUC
                            label='รถยนต์ประเภท 2 (รถยนต์นั่งส่วนบุคคลเกิน 7 คน)'
                            // onChange={(ev) => handleSetNull('carLicense2No')}
                            name={'isCarLicense2'} isShowHead={false}
                            onChange={(ev) => handleChangeUnderExam('carLicense2No', 'isCarLicense2UnderExam')}
                            disabled={isReadOnly}
                        />
                    </Col>
                </Row>
                {isCarLicense2 &&
                    <Row className="carLicense2No py-2">
                        <Col xs={24} md={16} className='px-2'>
                            {isCarLicense2UnderExam ?
                                <InputUC label='ใบอนุญาตขับรถยนต์ประเภท 2' name={'carLicense2No'} maxLength={20}
                                    disabled={true} placeholder={''} /> :
                                <InputUC label='ใบอนุญาตขับรถยนต์ประเภท 2' name={'carLicense2No'} maxLength={20}
                                    disabled={isReadOnly}
                                    required={car2LicenseData}
                                    onChange={(ev) => handleChange(ev, 'carLicense2No')} />
                            }
                        </Col>
                        <Col xs={24} md={8} className={`px-2 flex ${isMobile ? 'justify-start' : 'justify-center'} items-center div-checkbox`}>
                            <CheckBoxUC
                                disabled={isReadOnly}
                                label='อยู่ระหว่างการสอบ'
                                name={'isCarLicense2UnderExam'}
                                onChange={(ev) => handleSetNull('carLicense2No')} />
                        </Col>
                    </Row>
                }
                <AttachFile props={{ ...props, isLicenseChecked: isCarLicense2, isUnderExam: isCarLicense2UnderExam }} docType={'car2License'} />
                <Row className="isCarLicense3 py-2">
                    <Col span={24} className='px-2 div-checkbox-driving'>
                        <CheckBoxUC
                            label='รถยนต์ประเภท 3 (รถลากจูงหรือรถบรรทุก)'
                            // onChange={(ev) => handleSetNull('carLicense3No')}
                            name={'isCarLicense3'} isShowHead={false}
                            onChange={(ev) => handleChangeUnderExam('carLicense3No', 'isCarLicense3UnderExam')}
                            disabled={isReadOnly}
                        />
                    </Col>
                </Row>
                {isCarLicense3 &&
                    <Row className="carLicense3No py-2">
                        <Col xs={24} md={16} className='px-2'>
                            {isCarLicense3UnderExam ?
                                <InputUC label='ใบอนุญาตขับรถยนต์ประเภท 3' name={'carLicense3No'} maxLength={20}
                                    disabled={true} placeholder={''} /> :
                                <InputUC label='ใบอนุญาตขับรถยนต์ประเภท 3' name={'carLicense3No'} maxLength={20}
                                    disabled={isReadOnly}
                                    required={car3LicenseData}
                                    onChange={(ev) => handleChange(ev, 'carLicense3No')} />
                            }
                        </Col>
                        <Col xs={24} md={8} className={`px-2 flex ${isMobile ? 'justify-start' : 'justify-center'} items-center div-checkbox`}>
                            <CheckBoxUC disabled={isReadOnly} label='อยู่ระหว่างการสอบ' name={'isCarLicense3UnderExam'} onChange={(ev) => handleSetNull('carLicense3No')} />
                        </Col>
                    </Row>
                }
                <AttachFile props={{ ...props, isLicenseChecked: isCarLicense3, isUnderExam: isCarLicense3UnderExam }} docType={'car3License'} />
                <Row className="isCarLicense4 py-2">
                    <Col span={24} className='px-2 div-checkbox-driving'>
                        <CheckBoxUC
                            disabled={isReadOnly}
                            label='รถยนต์ประเภท 4 (รถขนส่งวัตถุอันตราย)'
                            name={'isCarLicense4'} isShowHead={false}
                            onChange={(ev) => handleChangeUnderExam('carLicense4No', 'isCarLicense4UnderExam')}
                        />
                    </Col>
                </Row>
                {isCarLicense4 &&
                    <Row className="carLicense4No py-2">
                        <Col xs={24} md={16} className='px-2'>
                            {isCarLicense4UnderExam ?
                                <InputUC label='ใบอนุญาตขับรถยนต์ประเภท 4' name={'carLicense4No'} maxLength={20}
                                    disabled={true} placeholder={''} /> :
                                <InputUC label='ใบอนุญาตขับรถยนต์ประเภท 4' name={'carLicense4No'} maxLength={20}
                                    disabled={isReadOnly}
                                    required={car4LicenseData}
                                    onChange={(ev) => handleChange(ev, 'carLicense4No')} />
                            }
                        </Col>
                        <Col xs={24} md={8} className={`px-2 flex ${isMobile ? 'justify-start' : 'justify-center'} items-center div-checkbox`}>
                            <CheckBoxUC
                                disabled={isReadOnly}
                                label='อยู่ระหว่างการสอบ'
                                name={'isCarLicense4UnderExam'}
                                onChange={(ev) => handleSetNull('carLicense4No')} />
                        </Col>
                    </Row>
                }
                <AttachFile props={{ ...props, isLicenseChecked: isCarLicense4, isUnderExam: isCarLicense4UnderExam }} docType={'car4License'} />

            </div>
        </>
    )
    // }

    // return (
    //     <div className='div-cap-lang w-full'>
    //         <HeaderBarAdd title={'ความสามารถในการขับขี่'} disabled={true} isShow={false} />
    //         <FormDriving />
    //     </div>
    // )
}

export default CapabilityDriving